import React, { useCallback } from 'react';
import ReportHeader from '../../components/reports/shared/report-header';
import ValuesFitResults from '../../components/reports/shared/results/values-fit-results';
import { LEADER_VALUE_TIPS } from '../../components/reports/shared/tips/acumen-values-experience-tips';
import ExperienceJudgmentResults from '../../components/reports/shared/results/experience-judgment-results';
import RecommendationsPersonalityTips from '../../components/reports/shared/tips/recommendations-personality-tips';
import CompetenciesJudgmentTips from '../../components/reports/shared/tips/competencies-judgment-tips';
import ReportPdfHeader from '../../components/reports/shared/report-pdf-header';
import LeaderReportSummary from '../../components/reports/leader/leader-report-summary';
import LeaderCompetenciesStrengthsWeaknesses from '../../components/reports/leader/leader-competencies-alignment-strengths-weaknesses';
import LeaderManagerCoachingTipsIntro from '../../components/reports/leader/leader-manager-coaching-tips-intro';
import PagedAcumenValuesExperienceTips from '../../components/reports/shared/tips/paged-acumen-values-experience-tips';
import LeaderCompetenciesSummary from '../../components/reports/leader/leader-competencies-summary';
import CoachingPersonalityPage1 from '../../components/reports/shared/results/coaching-personality-page-1';
import CoachingPersonalityPage2 from '../../components/reports/shared/results/coaching-personality-page-2';
import { generateCompetenciesCommentsPdfPages } from '../../components/reports/shared/report-util';
import LeaderConfidentialPage from '../../components/reports/leader/leader-confidential-page';
import LeaderInstructionsPage1 from '../../components/reports/leader/leader-instructions-page-1';
import LeaderInstructionsPage2 from '../../components/reports/leader/leader-instructions-page-2';
import { REPORT_TYPE } from '../../utils/constants';
import { FeedbackReport } from '../../components/reports/shared/results/feedback-report';

function LeaderCoachingReport({ candidate, creatingPdf, withSummary = false }) {
  const openEndedCommentsPages = useCallback(() => {
    return generateCompetenciesCommentsPdfPages(creatingPdf, candidate);
  }, [candidate, creatingPdf]);

  return (
    <>
      <div className="print-page">
        <LeaderConfidentialPage candidate={candidate} />
      </div>
      <div className="print-page">
        <LeaderInstructionsPage1 />
      </div>
      <div className="print-page">
        <LeaderInstructionsPage2 />
      </div>
      {withSummary && (
        <div className="print-page print-heading">
          <ReportPdfHeader />
          <ReportHeader candidate={candidate} header="Leader's Coaching Report" />
          <LeaderReportSummary candidate={candidate} speedometers={true} />
        </div>
      )}
      <FeedbackReport candidate={candidate} reportType={REPORT_TYPE.development} creatingPdf={creatingPdf} />
      <div className="print-page">
        <CoachingPersonalityPage1 candidate={candidate} reportType={REPORT_TYPE.development} />
      </div>
      <div className="print-page">
        <CoachingPersonalityPage2 candidate={candidate} reportType={REPORT_TYPE.development} />
      </div>
      <div className="print-page">
        <ValuesFitResults candidate={candidate} reportType={REPORT_TYPE.development} />
      </div>
      <div className="print-page">
        <ExperienceJudgmentResults candidate={candidate} reportType={REPORT_TYPE.development} />
      </div>
      <div className="print-page">
        <LeaderCompetenciesSummary candidate={candidate} reportType={REPORT_TYPE.development} />
      </div>
      <div className="print-page">
        <LeaderCompetenciesStrengthsWeaknesses
          candidate={candidate}
          withComments={!creatingPdf}
          reportType={REPORT_TYPE.development}
        />
      </div>
      {openEndedCommentsPages()}
      <div className="print-page">
        <RecommendationsPersonalityTips
          candidate={candidate}
          nTips={2}
          tipsIntro={<LeaderManagerCoachingTipsIntro />}
          reportType={REPORT_TYPE.development}
        />
      </div>
      <PagedAcumenValuesExperienceTips
        candidate={candidate}
        valuesTips={LEADER_VALUE_TIPS}
        creatingPdf={creatingPdf}
        reportType={REPORT_TYPE.development}
      />
      <div className="print-page">
        <CompetenciesJudgmentTips candidate={candidate} nTips={2} reportType={REPORT_TYPE.development} />
      </div>
    </>
  );
}

export default LeaderCoachingReport;
